// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  width: 300px;
  z-index: 996;
  transition: all 0.3s;
  padding: 20px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #aab7cf transparent;
  box-shadow: 0px 20px rgba(1, 41, 112, 0.1);
  background-color: #fff;
}

@media (max-width: 1199px) {
  .sidebar {
    left: -300px;
  }
}

.sidebar::-webkit-scrollbar {
  width: 5px;
  height: 8px;
  background-color: #fff;
}

.sidebar::-webkit-scrollbar-thumb {
  background-color: #aab7cf;
}

@media (min-width: 1200px) {
  #main,
  #footer {
    margin-left: 300px;
  }
}

@media (min-width: 1199px) {
  .toggle-sidebar .sidebar {
    left: 0;
  }
}

@media (min-width: 1200px) {
  .toggle-sidebar #main,
  .toggle-sidebar #footer {
    margin-left: 0;
  }

  .toggle-sidebar .sidebar {
    left: -300px;
  }
}

.sidebar-nav {
  padding: 0;
  margin: 0;
  list-style: none;
}

.sidebar-nav li {
  padding: 0;
  margin: 0;
  list-style: none;
}

.sidebar-nav .nav-item {
  margin-bottom: 5px;
}

.sidebar-nav .nav-heading {
  font-size: 11px;
  text-transform: uppercase;
  color: #899bbd;
  font-weight: 600;
  margin: 10px 0 5px 15px;
}

.sidebar-nav .nav-link {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #4154f1;
  transition: 0.3;
  background: #f6f9ff;
  padding: 10px 15px;
  border-radius: 4px;
}

.sidebar-nav .nav-link i {
  font-size: 16px;
  margin-right: 10px;
  color: #4154f1;
}

.sidebar-nav .nav-link.collapsed {
  color: #012970;
  background: #fff;
}

.sidebar-nav .nav-link.collapsed i {
  color: #899bbd;
}

.sidebar-nav .nav-link:hover {
  color: #4154f1;
  background: #f6f9ff;
}

.sidebar-nav .nav-link:hover i {
  color: #4154f1;
}

.sidebar-nav .nav-link .bi-chevron-down {
  margin-right: 0;
  transition: transform 0.2s ease-in-out;
}

.sidebar-nav .nav-link:not(.collapsed) .bi-chevron-down {
  transform: rotate(180deg);
}

.sidebar-nav .nav-content {
  padding: 5px 0 0 0;
  margin: 0;
}

.sidebar-nav .nav-content a {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #012970;
  transition: 0.3;
  padding: 10px 0 10px 40px;
  transition: 0.3s;
}

.sidebar-nav .nav-content a i {
  font-size: 16px;
  margin-right: 8px;
  line-height: 0;
  border-radius: 50%;
}

.sidebar-nav .nav-content a:hover,
.sidebar-nav .nav-content a:active {
  color: #4154f1;
}

.sidebar-nav .nav-content a.active i {
  background-color: #4154f1;
}

/**/
.sidebar-nav .nav-item .selected {
  color: #4154f1;
  background-color: #e0e9f9;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/sideBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE;;IAEE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,GAAG;AACH;EACE,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".sidebar {\n  position: fixed;\n  top: 60px;\n  left: 0;\n  bottom: 0;\n  width: 300px;\n  z-index: 996;\n  transition: all 0.3s;\n  padding: 20px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #aab7cf transparent;\n  box-shadow: 0px 20px rgba(1, 41, 112, 0.1);\n  background-color: #fff;\n}\n\n@media (max-width: 1199px) {\n  .sidebar {\n    left: -300px;\n  }\n}\n\n.sidebar::-webkit-scrollbar {\n  width: 5px;\n  height: 8px;\n  background-color: #fff;\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n  background-color: #aab7cf;\n}\n\n@media (min-width: 1200px) {\n  #main,\n  #footer {\n    margin-left: 300px;\n  }\n}\n\n@media (min-width: 1199px) {\n  .toggle-sidebar .sidebar {\n    left: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .toggle-sidebar #main,\n  .toggle-sidebar #footer {\n    margin-left: 0;\n  }\n\n  .toggle-sidebar .sidebar {\n    left: -300px;\n  }\n}\n\n.sidebar-nav {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.sidebar-nav li {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.sidebar-nav .nav-item {\n  margin-bottom: 5px;\n}\n\n.sidebar-nav .nav-heading {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #899bbd;\n  font-weight: 600;\n  margin: 10px 0 5px 15px;\n}\n\n.sidebar-nav .nav-link {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 600;\n  color: #4154f1;\n  transition: 0.3;\n  background: #f6f9ff;\n  padding: 10px 15px;\n  border-radius: 4px;\n}\n\n.sidebar-nav .nav-link i {\n  font-size: 16px;\n  margin-right: 10px;\n  color: #4154f1;\n}\n\n.sidebar-nav .nav-link.collapsed {\n  color: #012970;\n  background: #fff;\n}\n\n.sidebar-nav .nav-link.collapsed i {\n  color: #899bbd;\n}\n\n.sidebar-nav .nav-link:hover {\n  color: #4154f1;\n  background: #f6f9ff;\n}\n\n.sidebar-nav .nav-link:hover i {\n  color: #4154f1;\n}\n\n.sidebar-nav .nav-link .bi-chevron-down {\n  margin-right: 0;\n  transition: transform 0.2s ease-in-out;\n}\n\n.sidebar-nav .nav-link:not(.collapsed) .bi-chevron-down {\n  transform: rotate(180deg);\n}\n\n.sidebar-nav .nav-content {\n  padding: 5px 0 0 0;\n  margin: 0;\n}\n\n.sidebar-nav .nav-content a {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: #012970;\n  transition: 0.3;\n  padding: 10px 0 10px 40px;\n  transition: 0.3s;\n}\n\n.sidebar-nav .nav-content a i {\n  font-size: 16px;\n  margin-right: 8px;\n  line-height: 0;\n  border-radius: 50%;\n}\n\n.sidebar-nav .nav-content a:hover,\n.sidebar-nav .nav-content a:active {\n  color: #4154f1;\n}\n\n.sidebar-nav .nav-content a.active i {\n  background-color: #4154f1;\n}\n\n/**/\n.sidebar-nav .nav-item .selected {\n  color: #4154f1;\n  background-color: #e0e9f9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
